<template>
  <div v-if="isInsideFacility" class="facility-segment">
    <facility-dropdown
      v-model="menuOpen"
      :facilities="accessibleEntries"
      :current-facility-id="currentFacilityId"
      :current-facility-name="currentFacilityName"
      :loading="loading"
      :error="error"
      @open="onMenuOpen"
      @retry="onRetry"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FacilityDropdown from '@/features/Facility/components/FacilityDropdown.vue';

export default {
  name: 'FacilitySegment',
  components: { FacilityDropdown },
  data() {
    return {
      menuOpen: false,
    };
  },
  computed: {
    ...mapGetters('FACILITY', {
      currentFacility: 'GET_FACILITY',
      accessibleEntries: 'GET_ACCESSIBLE_ENTRIES',
      loading: 'GET_ACCESSIBLE_LOADING',
      error: 'GET_ACCESSIBLE_ERROR',
    }),
    isInsideFacility() {
      return this.$route.matched.some(
        (record) => record.meta && record.meta.facilityScope
      );
    },
    currentFacilityId() {
      // Prefer the store pointer; fall back to the route param for cold deep-links
      // before FACILITY/SET_FACILITY has been committed.
      if (this.currentFacility && this.currentFacility.id) {
        return this.currentFacility.id;
      }
      return this.$route.params.id || null;
    },
    currentFacilityName() {
      return (this.currentFacility && this.currentFacility.name) || '';
    },
  },
  watch: {
    '$route.params.id'(newId, oldId) {
      // Close the dropdown when the route changes (either from navigation
      // triggered by the dropdown itself or from elsewhere in the app).
      if (newId !== oldId) {
        this.menuOpen = false;
      }
    },
  },
  methods: {
    onMenuOpen() {
      // Delegate caching to the action — it is a no-op when the cache is fresh.
      this.$store.dispatch('FACILITY/FETCH_ACCESSIBLE');
    },
    onRetry() {
      this.$store.dispatch('FACILITY/FETCH_ACCESSIBLE', { force: true });
    },
  },
};
</script>

<style lang="scss" scoped>
.facility-segment {
  display: inline-flex;
  align-items: center;
}
</style>
